import React from "react";
import styles from "../../../styles/pages/profile/ProfilePage.module.css";

const ActivityViewSkeleton = () => {
  return (
    <div className={styles.contentSection}>
      <div className={styles.sectionHeader}>
        <div>
          <div className={`${styles.skeleton} ${styles.skeletonTitle}`}></div>
          <div
            className={`${styles.skeleton} ${styles.skeletonSubtitle}`}
          ></div>
        </div>
      </div>

      <div className={styles.activityTimeline}>
        {[1, 2, 3, 4, 5].map((i) => (
          <div key={i} className={styles.activityItem}>
            <div className={styles.activityIcon}>
              <div
                className={`${styles.skeleton} ${styles.skeletonIcon}`}
              ></div>
            </div>
            <div className={styles.activityContent}>
              <div
                className={`${styles.skeleton} ${styles.skeletonText}`}
                style={{ width: "80%", height: "20px", marginBottom: "8px" }}
              ></div>
              <div
                className={`${styles.skeleton} ${styles.skeletonText}`}
                style={{ width: "30%" }}
              ></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActivityViewSkeleton;
